module.exports = ["ahora",["hace %s segundo","hace %s segundos"],["hace %s minuto","hace %s minutos"],["hace %s hora","hace %s horas"],["hace %s día","hace %s días"],["hace %s semana","hace %s semanas"],["hace %s mes","hace %s meses"],["hace %s año","hace %s años"]]


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-timeago/locales/es-ES.json
// module id = sXeN
// module chunks = 1